<template>
  <v-layout justify-center>
    <div>
      <v-layout>
        <v-flex xm12 md4 offset-md4 class="text-sm-center">
          <span class="headline">LIST</span><br />
        </v-flex>
        <v-flex xm12 sm4 class="title text-sm-right">
          <v-btn fab outline small value="email" color="primary" @click="buildEmail()" :disabled="!selected">
            <v-icon>email</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>

      <v-flex xs12>
        <vue-good-table
          ref="my-table"
          styleClass="vgt-table striped bordered"
          :max-height=this.height
          :fixed-header="true"
          :columns="columns"
          :isLoading=this.isTableLoading
          :rows="rows"
          @on-cell-click="onCellClick"
          :select-options="{
            enabled: true,
            selectOnCheckboxOnly: true
          }"
          :search-options="{
            enabled: true
          }">
          <template slot="loadingContent">
            <div>
              <v-progress-circular
                :size="50"
                :width="7"
                color="blue"
                indeterminate
              ></v-progress-circular>
            </div>
          </template>
          <div slot="table-actions-bottom">
            <span class="body-2" style="padding-left: 20px;">Number of records: {{ totalCount }}</span>
          </div>
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'actions'">
              <div class="text-xs-center">
                <v-avatar
                  color="blue lighten-4"
                  class="mr-2 mt-2"
                  size="30"
                  style="cursor: pointer;"
                  @click="editItem(props)"
                >
                  <v-icon small>edit</v-icon>
                </v-avatar>
              </div>
            </span>
            <span v-else>
              {{props.formattedRow[props.column.field]}}
            </span>
          </template>
        </vue-good-table>
      </v-flex>

      <v-btn
        fab
        bottom
        right
        color="blue"
        dark
        fixed
        class="add-button-bottom"
        @click="addVendor"
      >
        <v-icon>add</v-icon>
      </v-btn>

      <EmailForm
        :visible="showEmailForm"
        :items="emailList"
        :selectedItems="emails"
        :emailTemplates="emailTemplates"
        :emailTemplateId="0"
        :rows="varList"
        section="Vendor"
        persistent
        @close="closeThis"
      />

      <InternalForm
        :visible="showEvalForm"
        :item="evalItem"
        :key="evalItem.id"
        :memberList="memberList"
        :currentYear="currentYear"
        persistent
        @close="closeThisEval"
      />

      <v-dialog v-model="dialog" max-width="1000px" persistent>
        <v-card >
          <v-toolbar dark color="primary">
            <v-btn icon dark @click="close">
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>Add Vendor</v-toolbar-title>
          </v-toolbar>

          <v-form
              ref="form"
              v-model="valid"
              lazy-validation
          >
          <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs6 md3>
                    <v-select
                      v-model="editedItem.new"
                      :items="yesNo"
                      label="New"
                    ></v-select>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      v-model="editedItem.name"
                      label="Company"
                      ref="focusName"
                      :rules="[v => !!v || 'Company is required']"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      v-model="editedItem.address"
                      label="Address"
                      :rules="[v => !!v || 'Address is required']"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-layout wrap>
                      <v-flex xs12 md6>
                        <v-text-field
                          v-model="editedItem.city"
                          label="City"
                          :rules="[v => !!v || 'City is required']"
                          required
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 md6>
                        <v-text-field
                          v-model="editedItem.state"
                          label="State/Province"
                          :rules="[v => !!v || 'State/Province is required']"
                          required
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 md6>
                        <v-text-field
                          v-model="editedItem.phone"
                          label="Phone"
                          :rules="[v => !!v || 'Phone is required']"
                          required
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 md6>
                        <v-text-field
                          v-model="editedItem.zip"
                          label="Postal Code"
                          :rules="[v => !!v || 'Postal Code is required']"
                          required
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 md6>
                        <v-text-field
                          v-model="editedItem.country"
                          label="Country"
                          :rules="[v => !!v || 'Country is required']"
                          required
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-text-field
                      v-model="editedItem.webSite"
                      label="Website"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-textarea
                      v-model="editedItem.profile"
                      label="Company Profile, Booth Size, Power Requirement and Product Description"
                      prepend-icon="notes"
                      :rules="[v => !!v || 'Company Provile is required']"
                      required
                    ></v-textarea>
                  </v-flex>
                  <v-flex class="title text-xs-center mt-4" xs12>
                    <span class="blue--text">PRIMARY CONTACT</span>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-text-field
                      v-model="editedItem.firstName"
                      @keyup.enter="save"
                      label="First Name"
                      :rules="[v => !!v || 'First Name is required']"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-text-field
                      v-model="editedItem.lastName"
                      @keyup.enter="save"
                      label="Last Name"
                      :rules="[v => !!v || 'Last Name is required']"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md4>
                    <v-text-field
                      v-model="editedItem.contactPhone"
                      label="Phone"
                      prepend-icon="phone"
                      :rules="[v => !!v || 'Phone is required']"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md8>
                    <v-text-field
                      v-model="editedItem.title"
                      label="Title"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md4>
                    <v-text-field
                      v-model="editedItem.mobile"
                      label="Mobile"
                      prepend-icon="stay_current_portrait"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md8>
                    <v-text-field
                      prepend-icon="email"
                      label="Email"
                      type="email"
                      v-model="editedItem.email"
                      :rules="emailRules"
                      required
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            <v-alert :value="error" type="warning" transition="scale-transition">
              <span v-html="error"></span>
            </v-alert>

          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="save">Save</v-btn>
          </v-card-actions>
        </v-form>
        </v-card>
      </v-dialog>

      <v-dialog v-model="viewDialog" max-width="500px">
        <v-card>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                  <v-flex xs12 class="text-xs-center text-sm-center">
                    <span class="headline">{{ editedItem.name }}</span><br />
                    <span class="subheading">Booth(s): {{ editedItem.title }}</span><br />
                    {{ editedItem.address }}<br />
                    {{ editedItem.city }}, {{ editedItem.state }} {{ editedItem.zip }}
                  </v-flex>
                  <v-flex xs12>
                    <v-btn
                      v-if="editedItem.email"
                      block
                      color="blue-grey"
                      class="white--text"
                      :href="sendEmail"
                    >
                      Email {{editedItem.firstName}}
                      <v-icon right dark>email</v-icon>
                    </v-btn>
                    <v-btn
                      v-if="editedItem.cellPhone"
                      block
                      color="blue-grey"
                      class="white--text"
                      :href="callMobile"
                    >
                      Call Primary
                      <v-icon right dark>mobile_screen_share</v-icon>
                    </v-btn>
                    <v-btn
                      v-if="editedItem.homePhone"
                      block
                      color="blue-grey"
                      class="white--text"
                      :href="callHome"
                    >
                      Call Primary Onsite
                      <v-icon right dark>mobile_screen_share</v-icon>
                    </v-btn>
                    <v-btn
                      v-if="editedItem.workPhone"
                      block
                      color="blue-grey"
                      class="white--text"
                      :href="callWork"
                    >
                      Call Secondary Onsite
                      <v-icon right dark>mobile_screen_share</v-icon>
                    </v-btn>
                  </v-flex>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click.native="close">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-snackbar
        v-model="snackbar.show"
        :color="snackbar.color"
        :multi-line=true
        :timeout="6000"
      >
        {{ snackbar.message }}
        <v-btn
          dark
          flat
          @click="snackbar.show = false"
        >
          Close
        </v-btn>
      </v-snackbar>
    </div>
  </v-layout>
</template>

<script>
import Api from '@/services/Api'
import VLazyImage from 'v-lazy-image'
import { VueGoodTable } from 'vue-good-table'
import 'vue-good-table/dist/vue-good-table.css'
import EmailForm from '../forms/EmailTempForm'
import InternalForm from './InternalForm.vue'
import XLSX from 'xlsx'

export default {
  props: ['visible', 'currentYear'],

  components: {
    VueGoodTable,
    VLazyImage,
    EmailForm,
    InternalForm
  },
  data () {
    return {
      valid: true,
      myId: this.$store.state.user.id,
      myName: this.$store.state.user.fullName,
      myEmail: this.$store.state.user.email,
      page: 'Vendor List',
      searchSelect: [],
      searchType: '',
      isAdmin: this.$store.state.isAdmin,
      isCommChair: false,
      dialog: false,
      error: '',
      viewDialog: false,
      loading: false,
      isTableLoading: false,
      isMounted: false,
      snackbar: {
        show: false,
        color: '',
        message: ''
      },
      editedIndex: -1,
      height: 0,
      columns: [
        {
          label: 'Company Name',
          field: 'name',
          thClass: 'text-center',
          html: true
        },
        {
          label: 'Booth',
          field: 'booths',
          thClass: 'hidden-sm-and-down text-center',
          tdClass: 'hidden-sm-and-down',
          type: 'text'
        },
        {
          label: 'Name',
          field: 'contactName',
          thClass: 'hidden-sm-and-down text-center',
          tdClass: 'hidden-sm-and-down',
          html: true
        },
        {
          label: 'Phone',
          field: 'phone',
          thClass: 'hidden-sm-and-down text-center',
          tdClass: 'hidden-sm-and-down',
          type: 'text'
        },
        {
          label: 'Email',
          field: 'email',
          thClass: 'hidden-sm-and-down text-center',
          tdClass: 'hidden-sm-and-down',
          html: true
        },
        {
          label: 'Waitlist',
          field: 'waitlist',
          thClass: 'hidden-sm-and-down text-center',
          tdClass: 'hidden-sm-and-down',
          type: 'text'
        },
        {
          label: 'Category',
          field: 'vendorCategory',
          thClass: 'hidden-sm-and-down text-center',
          tdClass: 'hidden-sm-and-down',
          type: 'text'
        },
        {
          label: 'Type',
          field: 'type',
          thClass: 'hidden-sm-and-down text-center',
          tdClass: 'hidden-sm-and-down',
          type: 'text'
        },
        {
          label: 'Edit',
          field: 'actions',
          thClass: 'text-center',
          tdClass: 'text-center',
          sortable: false,
          hidden: false,
          html: true,
          width: '60px'
        }
      ],
      committeeHeader: {},
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+/.test(v) || 'E-mail must be valid'
      ],
      callMobile: '',
      // newRows: [],
      rows: [],
      editedItem: {},
      evalItem: {},
      showEmailForm: false,
      showEvalForm: false,
      emails: [],
      cc: [],
      bcc: [],
      emailList: [],
      varList: [],
      ccList: [],
      bccList: [],
      emailText: '',
      memberList: [],
      emailTemplates: [],
      yesNo: ['Yes', 'No'],
      categories: [],
      booths: []
    }
  },

  created () {
    this.currentYear = this.$store.state.currentYear
    this.searchType = this.$store.state.currentYear
    this.yearList()

    this.isTableLoading = true

    if (this.$route.params.currentYear) {
      this.currentYear = this.$route.params.currentYear
    } else {
      this.currentYear = this.$store.state.currentYear
    }

    this.loading = true

    window.addEventListener('resize', this.handleResize)
    this.handleResize()

    this.getCategories()
    this.getBooths()
    this.getMembers()
    // this.getNewVendors()
    this.getVendors()
    this.getEmailTemplates()

    this.loading = false
    console.log('Chair', this.isCommChair)

    // console.log(this.$refs)
  },

  mounted () {
    this.isMounted = true
  },

  destroyed () {
    window.removeEventListener('resize', this.handleResize)
  },

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
    },

    selected () {
      if (!this.isMounted) {
        return
      }

      return this.$refs['my-table'].selectedRowCount > 0
    },

    totalCount () {
      if (!this.isMounted) {
        return
      }

      return this.$refs['my-table'].totalRowCount
    }
  },

  watch: {
    currentYear: {
      handler: function (val, oldVal) {
        this.getBooths()
        // this.getNewVendors()
        this.getVendors()
      },
      deep: true
    }
  },

  methods: {
    yearList () {
      for (let i = this.$store.state.currentYear; i >= 2013; i--) {
        this.searchSelect.push(i)
      }
    },

    async getCategories () {
      try {
        const response = await Api().get('categories/')
        this.categories = response.data
        this.isTableLoading = false
      } catch (error) {
        this.error = error.response.data.error
      }
    },

    async getBooths () {
      try {
        const response = await Api().get('booths/' + this.currentYear)
        this.booths = response.data
        this.isTableLoading = false
      } catch (error) {
        this.error = error.response.data.error
      }
    },

    async getMembers () {
      try {
        let item = {}
        let control = {}

        const controls = this.$store.state.controls
        control = controls.find(item => item === 'Vendor')
        console.log('control', control)

        console.log('controls', controls)

        if (control) {
          this.isCommChair = true
        } else {
          const response = await Api().get('get_committee_by_code/CON/' + this.currentYear)
          this.memberList = response.data.committee.Users
          this.memberList.unshift({id: 0, fullName: 'None'})
          console.log(this.memberList)

          item = this.memberList.find(item => item.id === this.myId)

          if (item.UserCommittee.title === 'Chair' || item.UserCommittee.title === 'Assist Chair') {
            console.log('yes')
            this.isCommChair = true
          }

          console.log('item', this.isCommChair)
        }
        this.isTableLoading = false
      } catch (error) {
        this.error = error.response.data.error
      }
    },

    handleResize () {
      const height = window.innerHeight - 360
      this.height = height + 'px'
    },

    addVendor () {
      this.dialog = true
    },

    async save () {
      try {
        this.editedItem.year = this.currentYear
        this.editedItem.new = 'Yes'
        this.editedItem.UserId = this.myId

        if (this.$refs.form.validate()) {
          const response = await Api().post('vendors', this.editedItem)

          this.getBooths()
          // this.getNewVendors()
          this.getVendors()
          this.editedItem = {}

          this.snackbar.message = response.data.message
          this.snackbar.color = 'success'
          this.snackbar.show = true
        } else {
          this.snackbar.message = 'You have some errors on the page!'
          this.snackbar.color = 'error'
          this.snackbar.show = true
        }
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    editItem (props) {
      this.evalItem = props.row

      this.showEvalForm = true
    },

    // async getNewVendors () {
    //   try {
    //     const response = await Api().get('new_vendors/' + this.currentYear)

    //     const vendorList = response.data
    //     console.log('NEW', vendorList)

    //     for (let i in vendorList) {
    //       let rep = ''

    //       if (vendorList[i].VendorCategoryId > 0) {
    //         let vendorCategory = this.categories.find(({ id }) => id === vendorList[i].VendorCategoryId)
    //         vendorList[i].vendorCategory = vendorCategory.category
    //       } else {
    //         vendorList[i].vendorCategory = ''
    //       }

    //       if (vendorList[i].VendorDetails[0].User) {
    //         let user = vendorList[i].VendorDetails[0].User
    //         rep = user.fullName
    //       }

    //       // let rating = ''
    //       // if (vendorList[i].VendorDetails[0].rating) {
    //       //   rating = '-' + vendorList[i].VendorDetails[0].rating
    //       // }

    //       vendorList[i].type = vendorList[i].VendorDetails[0].checkIn
    //       vendorList[i].waitlist = vendorList[i].new
    //       vendorList[i].rep = rep
    //       vendorList[i].contactName = vendorList[i].VendorContacts[0].firstName + ' ' + vendorList[i].VendorContacts[0].lastName
    //       vendorList[i].email = vendorList[i].VendorContacts[0].email
    //     }

    //     this.newRows = vendorList

    //     this.isTableLoading = false
    //   } catch (error) {
    //     this.error = error.response.data.error
    //     this.snackbar.message = error.response.data.error
    //     this.snackbar.color = 'error'
    //     this.snackbar.show = true
    //   }
    // },

    async onCellClick (params) {
      try {
        console.log('props', params.row)
        console.log('props', params.row.VendorDetails[0].primaryContact)
        if (params.column.field === 'name') {
          this.editedItem.id = params.row.id
          this.editedItem.name = params.row.name
          this.editedItem.title = params.row.booths
          this.editedItem.address = params.row.address
          this.editedItem.city = params.row.city
          this.editedItem.state = params.row.state
          this.editedItem.zip = params.row.zip

          const response = await Api().get('vendor_contact/' + params.row.VendorDetails[0].primaryContact)
          const contact = response.data
          if (contact) {
            this.editedItem.cellPhone = contact.mobile
            this.callMobile = 'tel:' + contact.mobile
          }

          const response1 = await Api().get('vendor_contact/' + params.row.VendorDetails[0].primaryOnsite)
          const contact1 = response1.data
          if (contact1) {
            this.editedItem.homePhone = contact1.mobile
            this.homePhone = 'tel:' + contact1.mobile
          }

          const response2 = await Api().get('vendor_contact/' + params.row.VendorDetails[0].secondaryOnsite)
          const contact2 = response2.data
          if (contact2) {
            this.editedItem.workPhone = contact2.mobile
            this.workPhone = 'tel:' + contact2.mobile
          }

          this.viewDialog = true
        }
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async getEmailTemplates () {
      try {
        const response = await Api().get('get_email_templates/Vendor')
        this.emailTemplates = response.data
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async getVendors () {
      try {
        const response = await Api().get('vendors/' + this.currentYear)

        const vendorList = response.data
        console.log(vendorList)

        for (let i in vendorList) {
          let rep = ''

          if (vendorList[i].VendorCategoryId > 0) {
            let vendorCategory = this.categories.find(({ id }) => id === vendorList[i].VendorCategoryId)
            vendorList[i].vendorCategory = vendorCategory.category
          } else {
            vendorList[i].vendorCategory = ''
          }

          if (vendorList[i].VendorDetails[0].User) {
            rep = vendorList[i].VendorDetails[0].User
          }

          let booths = ''
          // console.log('vendor id', vendorList[i].id)
          // vendorList[i].VendorBooths = this.booths.find(({ VendorCompanyId }) => VendorCompanyId === vendorList[i].id)
          // console.log('vendor booth', vendorList[i].VendorBooths)

          for (let j in this.booths) {
            if (this.booths[j].VendorCompanyId === vendorList[i].id) {
              booths = booths + this.booths[j].boothNumber + ' '
            }
          }

          vendorList[i].type = vendorList[i].VendorDetails[0].checkIn
          vendorList[i].waitlist = vendorList[i].VendorDetails[0].insurance
          vendorList[i].rep = rep
          vendorList[i].booths = booths
          // console.log('test', vendorList[i])
          // let contact = vendorList[i].VendorContacts[0]
          // console.log('contact', contact.fullName)
          // vendorList[i].contactName = contact
          vendorList[i].contactName = vendorList[i].VendorContacts[0].firstName + ' ' + vendorList[i].VendorContacts[0].lastName
          vendorList[i].email = vendorList[i].VendorContacts[0].email
        }

        this.rows = vendorList

        this.isTableLoading = false
      } catch (error) {
        this.error = error.response.data.error
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    searchYear () {
      this.currentYear = this.searchType
      this.getBooths()
      this.getVendors()
    },

    buildEmail () {
      let vars = {}
      for (let i in this.rows) {
        this.emailList[i] = this.rows[i].VendorContacts[0].email
        vars.company = this.rows[i].name
        vars.password = this.rows[i].password
        vars.booth = this.rows[i].booths
        vars.email = this.rows[i].VendorContacts[0].email
        vars.firstName = this.rows[i].VendorContacts[0].firstName
        vars.lastName = this.rows[i].VendorContacts[0].lastName

        this.varList[i] = vars
        vars = {}
      }

      for (let i in this.$refs['my-table'].selectedRows) {
        this.emails[i] = this.$refs['my-table'].selectedRows[i].VendorContacts[0].email
      }

      this.showEmailForm = true

      if (this.emails.length > 9) {
        this.emailText = 'You are sending to ' + this.emails.length + ' email addresses'
        this.editTo = false
      } else {
        this.emailText = ''
        this.editTo = true
      }
    },

    onExport () {
      this.printMembers = this.rows.map(a => ({
        'Name': a.name,
        'Address': a.address,
        'City': a.city,
        'State': a.state,
        'Zip': a.zip,
        'Primary Phone': a.primaryPhone,
        'Secondayr Phone': a.secondaryPhone,
        'Email': a.email,
        'Age': a.age,
        'Height': a.height,
        'Weight': a.weight,
        'Parents': a.parents,
        'Notes': a.notes
      }))

      let membersWS = XLSX.utils.json_to_sheet(this.printMembers)

      let wb = XLSX.utils.book_new()

      if (!wb.Props) { wb.Props = {} }
      wb.Props.Title = 'Insert Title Here'

      XLSX.utils.book_append_sheet(wb, membersWS, this.committeeHeader.committeeCode)

      XLSX.writeFile(wb, this.currentYear + ' Mutton Busters.xlsx')
    },

    remove (item) {
      this.emails.splice(this.emails.indexOf(item), 1)
      this.emails = [...this.emails]
    },

    closeThis (item) {
      this.emails = []
      this.showEmailForm = false
    },

    closeThisEval (item) {
      this.evalItem = {}
      this.getVendors()
      this.showEvalForm = false
    },

    close () {
      this.initialImage = null
      this.dialog = false
      this.viewDialog = false
      this.showEmailForm = false
      this.showEvalForm = false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.vgt-fixed-header {
  z-index: 1;
}

.vgt-fixed-header th:last-child {
    /* Offset for the scrollbar, you may have to adjust this */
    width: calc(100% + 17px) !important;
}

.croppa-container {
  background-color: white;
  border: 3px solid black
}
</style>



// WEBPACK FOOTER //
// src/components/vendor/List.vue